// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lcard { display: flex; flex-direction: column; cursor: pointer; }
.lcard__img {
  position: relative;
  aspect-ratio: 9 / 16;
  border-radius: 6px;
  overflow: hidden;
  background: var(--line-soft);
}
/* La pieza se muestra completa; el espacio sobrante lo rellena el fondo de la
   propia foto (inline, calculado por el backend — ver ListingCard.js). */
.lcard__img img {
  display: block;
  width: 100%; height: 100%;
  object-fit: contain;
  transition: transform .35s;
}
.lcard:hover .lcard__img img { transform: scale(1.04); }

/* ── Action badge (top-right) ── */
.lcard__badge {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .08em;
  padding: 4px 8px;
  border-radius: 3px;
  color: #fff;
  text-transform: uppercase;
  line-height: 1;
  box-shadow: 0 1px 4px rgba(0,0,0,.18);
}
.lcard__badge--venta   { background: #e63946; }   /* rojo intenso */
.lcard__badge--cambio  { background: #f4b400; color: #1a1a1a; } /* amarillo dorado */
.lcard__badge--mostrar { background: #2a2a2a; }   /* oscuro neutro */

.lcard__body {
  padding: 10px 0 0;
  display: flex; flex-direction: column;
  flex: 1 1;
}
/* Allow up to 2 lines, but reserve the same height for every card so the grid stays justified */
.lcard__name {
  font-size: 13px; font-weight: 500;
  color: var(--ink);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: calc(13px * 1.3 * 2);
}
.lcard__meta {
  font-size: 12px; font-style: italic;
  color: var(--muted);
  margin-top: 2px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.lcard__price {
  font-size: 13px; font-weight: 600;
  color: var(--ink);
  margin-top: 6px;
}
.lcard__price--locked { color: var(--muted); font-weight: 500; }
`, "",{"version":3,"sources":["webpack://./src/components/ListingCard.css"],"names":[],"mappings":"AAAA,SAAS,aAAa,EAAE,sBAAsB,EAAE,eAAe,EAAE;AACjE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;yEACyE;AACzE;EACE,cAAc;EACd,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA,+BAA+B,sBAAsB,EAAE;;AAEvD,mCAAmC;AACnC;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;AACA,yBAAyB,mBAAmB,EAAE,IAAI,iBAAiB;AACnE,yBAAyB,mBAAmB,EAAE,cAAc,EAAE,EAAE,oBAAoB;AACpF,yBAAyB,mBAAmB,EAAE,IAAI,kBAAkB;;AAEpE;EACE,iBAAiB;EACjB,aAAa,EAAE,sBAAsB;EACrC,SAAO;AACT;AACA,gGAAgG;AAChG;EACE,eAAe,EAAE,gBAAgB;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,eAAe,EAAE,kBAAkB;EACnC,mBAAmB;EACnB,eAAe;EACf,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB;AAChE;AACA;EACE,eAAe,EAAE,gBAAgB;EACjC,iBAAiB;EACjB,eAAe;AACjB;AACA,wBAAwB,mBAAmB,EAAE,gBAAgB,EAAE","sourcesContent":[".lcard { display: flex; flex-direction: column; cursor: pointer; }\n.lcard__img {\n  position: relative;\n  aspect-ratio: 9 / 16;\n  border-radius: 6px;\n  overflow: hidden;\n  background: var(--line-soft);\n}\n/* La pieza se muestra completa; el espacio sobrante lo rellena el fondo de la\n   propia foto (inline, calculado por el backend — ver ListingCard.js). */\n.lcard__img img {\n  display: block;\n  width: 100%; height: 100%;\n  object-fit: contain;\n  transition: transform .35s;\n}\n.lcard:hover .lcard__img img { transform: scale(1.04); }\n\n/* ── Action badge (top-right) ── */\n.lcard__badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: .08em;\n  padding: 4px 8px;\n  border-radius: 3px;\n  color: #fff;\n  text-transform: uppercase;\n  line-height: 1;\n  box-shadow: 0 1px 4px rgba(0,0,0,.18);\n}\n.lcard__badge--venta   { background: #e63946; }   /* rojo intenso */\n.lcard__badge--cambio  { background: #f4b400; color: #1a1a1a; } /* amarillo dorado */\n.lcard__badge--mostrar { background: #2a2a2a; }   /* oscuro neutro */\n\n.lcard__body {\n  padding: 10px 0 0;\n  display: flex; flex-direction: column;\n  flex: 1;\n}\n/* Allow up to 2 lines, but reserve the same height for every card so the grid stays justified */\n.lcard__name {\n  font-size: 13px; font-weight: 500;\n  color: var(--ink);\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: calc(13px * 1.3 * 2);\n}\n.lcard__meta {\n  font-size: 12px; font-style: italic;\n  color: var(--muted);\n  margin-top: 2px;\n  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n}\n.lcard__price {\n  font-size: 13px; font-weight: 600;\n  color: var(--ink);\n  margin-top: 6px;\n}\n.lcard__price--locked { color: var(--muted); font-weight: 500; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
